import React from 'react';
import TawkToWidget from './TawkToWidget';
import AjudaWidget from './ajuda/AjudaWidget';
import { MODO_SUPORTE_CHAT } from '../config/suporteChat';

// Bolha de atendimento do canto inferior direito: o Tawk.to ou o chatbot "Ajuda", conforme
// REACT_APP_SUPORTE_CHAT no build (config/suporteChat.js). O código do Tawk continua para voltar
// rápido: basta o rebuild com REACT_APP_SUPORTE_CHAT=tawk.
const BolhaAtendimento = ({ modo = MODO_SUPORTE_CHAT }) => (modo === 'ia' ? <AjudaWidget /> : <TawkToWidget />);

export default BolhaAtendimento;
